export default "<p>claim-details works!</p>\r\n\r\n"